import { Label as _Label, LabelProps as _LabelProps } from "reactstrap";

    export const Label = _Label;
    export type LabelProps = _LabelProps;
    